import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.



function PrintPage() { 
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };
 
  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">adjust only when necessary.</h1>
            <p className="banner-description">
              Enhance your brand's presence with high-quality print materials designed to leave a lasting impression.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          {/* Background Image */}
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Main Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>

      <section className="about-section">
        {/* Section 1: What We Offer */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Premium Printing Solutions</strong></h2>
            <p>
              We offer a range of customizable print materials, from business cards to banners, to meet your unique needs.
            </p>
            <ul>
              <p><strong>Business Materials:</strong> High-quality business cards, brochures, and flyers.</p>
              <p><strong>Event Promotion:</strong> Posters, banners, and custom signage for events.</p>
              <p><strong>Brand Identity:</strong> Custom stationery and promotional materials.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m7.1.png" alt="Print Materials" />
          </div>
        </div>

        {/* Section 2: Why Choose Us */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Why Choose Our Print Services?</strong></h2>
            <p>
              Our professional printing services ensure your materials stand out with vibrant colors, sharp images, and durable finishes.
            </p>
            <ul>
              <p><strong>Fast Turnaround:</strong> Get your prints delivered in no time.</p>
              <p><strong>High-Quality Materials:</strong> We use premium paper and ink for every project.</p>
              <p><strong>Affordable Pricing:</strong> Competitive rates without compromising on quality.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m7.2.png" alt="Quality Prints" />
          </div>
        </div>

        {/* Section 3: Our Commitment */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Committed to Excellence in Print</strong></h2>
            <p>
              We are dedicated to providing top-tier print products that help elevate your brand’s image and business growth.
            </p>
            <a href="/shigjeta-shop" className="cta-button">Shop Now</a>
          </div>
          <div className="about-image">
            <img src="/img/m7.3.png" alt="Print Excellence" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default PrintPage;
